import type { WorkbookCatalogEntry } from '@erp/shared-types';

export type CatalogColumn = NonNullable<
  WorkbookCatalogEntry['columns']
>[number];

/** Past this many columns, the list offers a search. */
export const COLUMN_SEARCH_THRESHOLD = 8;

/** The columns whose name, label or description contains `query`, ignoring case. */
export function matchingColumns(
  columns: readonly CatalogColumn[],
  query: string,
): CatalogColumn[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return [...columns];
  return columns.filter((column) =>
    [column.name, column.label, column.description].some((text) =>
      text?.toLowerCase().includes(needle),
    ),
  );
}
